import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faUserCheck, } from "@fortawesome/free-solid-svg-icons";
import { Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useEffect, useState } from "react";
import SrvButtonLink from "../global/SrvButtonLink";
import SrvButton from "../global/SrvButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./CardUser.css"
import AvatarRound from "../AvatarRound";
import ErrorAdd from "../../util/ErrorAdd";

function CardUser({ idObject, idItem, idProject, idType, typeChangeHandler, /*changeHandler,*/ onlyRead }) {
    /*
    idType:
         1-Выполнят один из ответственных
         2-Выполняет каждый ответственный

    */
    /*
    idObject:
        ID	Name
        1	Задача
        2	Регулярная задача
        3	Доска
        4	Проект
        5	Пользователь
        6	Регулярная задача. Трекер
    */

    const stateUserList = useSelector((state) => state.userList);//Пользователи
    const stateProjectList = useSelector((state) => state.projectList);//Проекты
    const stateSize = useSelector((state) => state.size);//Размеры окна
    const stateTask = useSelector((state) => state.taskList);//Задачи
    const stateTaskR = useSelector((state) => state.taskRlist);//Регулярные задачи.
    const stateTaskRTracker = useSelector((state) => state.taskRTrackerList);//Регулярные задачи. Трекер

    const [modalShow, setModalShow] = useState(false);
    const [log, setLog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingAvailable, setLoadingAvailable] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);//Флаг загружены ли данные или нет
    const [data, setData] = useState([]);//Список пользователей задачи
    const [dataAvailable, setDataAvailable] = useState([]);//Список доступных пользователей задачи

    //   console.log('stateBoardTask', stateBoardTask)

    useEffect(() => {
        setLog(null);

        if (idItem != null) {
            /*
            ID	Name
                1	Задача
                2	Регулярная задача
                3	Доска
                4	Проект
                5	Пользователь
                6	Регулярная задача. Трекер
            */

            if (idObject === 1) {
                stateTask.listUser.filter(a => a.ID_Task === idItem).map(item => {
                    if (stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0) {
                        const user_ = {
                            ...item
                            , Changed: 0
                            , User_Name: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User
                            , Avatar: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small
                            , Find: 1
                        }
                        setData(prevValue => [...prevValue.filter(a => a.ID_User !== item.ID_User), user_])
                        setLoading(false);
                    }
                    else {
                        loadingNoFound(item)
                    }
                });
            }
            else if (idObject === 2) {
                stateTaskR.listUser.filter(a => a.ID_TaskR === idItem).map(item => {
                    if (stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0) {
                        const user_ = {
                            ...item
                            , Changed: 0
                            , User_Name: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User
                            , Avatar: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small
                            , Find: 1
                        }
                        setData(prevValue => [...prevValue.filter(a => a.ID_User !== item.ID_User), user_])
                        setLoading(false);
                    }
                    else {

                        loadingNoFound(item)
                    }
                });
            }
            else if (idObject === 6) {

                stateTaskRTracker.listUser.filter(a => a.ID_TaskR_Tracker === idItem).map(item => {
                    if (stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0) {
                        const user_ = {
                            ...item
                            , Changed: 0
                            , User_Name: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User
                            , Avatar: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small
                            , Find: 1
                        }
                        setData(prevValue => [...prevValue.filter(a => a.ID_User !== item.ID_User), user_])
                        setLoading(false);
                    }
                    else {
                        loadingNoFound(item)
                    }
                });
            }
        }
    }, [idItem, stateTask.listUser, stateTaskR.listUser, stateTaskRTracker.listUser, stateTaskRTracker.list/*, stateBoardTask.listUser*/]);

    //Догружаем удаленных пользователей
    function loadingNoFound(old_data) {
        axios.get('/api_main/company/userGet', { params: { ID_User: old_data.ID_User } })
            .then((res) => {
                if (res.data.Status === 1) {
                    const find_user = res.data.Data;
                    setData(prevValue => [...prevValue.filter(a => a.ID_User !== old_data.ID_User), { ...old_data, User_Name: find_user.Name_User + ' (удален)', Avatar: find_user.Avatar_Small, Find: 0 }])
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function changeHandler(idUser, idAction) {
        setDataAvailable(dataAvailable.map((item) => {
            if (item.ID_User === idUser & item.ID_Action !== idAction) {
                return { ...item, ID_Action: idAction, Changed: 1 }
            }
            else if (item.ID_User === idUser & item.ID_Action === idAction) {
                return { ...item, ID_Action: null, Changed: 1 }
            }
            else {
                return item
            }
        }))

        setData(data.map((item) => {
            if (item.ID_User === idUser & item.ID_Action !== idAction) {
                return { ...item, ID_Action: idAction, Changed: 1 }
            }
            else if (item.ID_User === idUser & item.ID_Action === idAction) {
                return { ...item, ID_Action: null, Changed: 1 }
            }
            else {
                return item
            }
        }))
    }

    function saveHundler() {

        setLoading(true);
        setLog(null);

        const data_ = dataAvailable.filter(a => a.Changed === 1).map((item) => {
            return { ...item, ID_User: item.ID_User, ID_Action: item.ID_Action }
        })

        if (data_.length > 0) {
            if (idObject === 1) {
                axios.post('/api_tracker/task/userSetMass', { ID_Task: idItem, Items: data_ })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            setLoading(false);
                            setModalShow(false);
                            setDataLoaded(false); //Делаем данные не загруженными, чтобы обновился компонент
                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            if (idObject === 2) {
                axios.post('/api_tracker/taskR/userSetMass', { ID_TaskR: idItem, Items: data_ })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            setLoading(false);
                            setModalShow(false);
                            setDataLoaded(false); //Делаем данные не загруженными, чтобы обновился компонент
                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
        else {
            setLoading(false);
            setModalShow(false);
            setDataLoaded(false);
        }


    }

    function editModalShow() {
        setModalShow(true);
        setDataAvailable([]);

        const All_User = stateProjectList.list.filter(a => a.ID === idProject)[0].All_User;

        if (All_User === true) {
            stateUserList.list.map((user) => {

                setDataAvailable(prev => [...prev, {
                    ID_User: user.ID_User
                    , Name_User: user.Name_User
                    , Avatar: user.Avatar_Small
                    , ID_Action: data.filter(a => a.ID_User === user.ID_User).length > 0 ? data.filter(a => a.ID_User === user.ID_User)[0].ID_Action : null
                    , ID_Role: user.ID_Role
                    , Name_Role: user.Name_Role
                }])
            })
        }
        else {
            stateUserList.list.map((user) => {
                if (stateProjectList.listUser.filter(a => a.ID_User === user.ID_User & a.ID_Project === idProject).length > 0 || user.ID_Role === 0 || user.ID_Role === 1) {
                    setDataAvailable(prev => [...prev, {
                        ID_User: user.ID_User
                        , Name_User: user.Name_User
                        , Avatar: user.Avatar_Small
                        , ID_Action: data.filter(a => a.ID_User === user.ID_User).length > 0 ? data.filter(a => a.ID_User === user.ID_User)[0].ID_Action : null
                        , ID_Role: user.ID_Role
                        , Name_Role: user.Name_Role
                    }])
                }
            })
        }
    }

    return (

        < div >
            {
                data.filter(a => a.ID_Action !== null).length === 0 && (
                    <div className="d-flex justify-content-center" style={{ height: '60px' }}>
                        <SrvButtonLink typeBtn="add" textBtn="Добавить ответственного" onClick={() => editModalShow(true)} />
                    </div>
                )
            }
            {
                stateSize.desktop === true ?
                    (
                        data.filter(a => a.ID_Action !== null).length > 0 && (
                            <div className="card_widget_body">
                                {onlyRead === false && (
                                    <div className="card_widget_btn_edit">
                                        <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => editModalShow()} />
                                    </div>
                                )}
                                <u>  {idType === 1 ? ("Выполняет один из:") : ("Выполняет каждый из:")}</u>
                                {data.filter(a => a.ID_Action !== null).sort((a, b) => a.User_Name > b.User_Name ? 1 : -1).map((user) => (
                                    <div key={user.ID_User} className="card_user_row">
                                        <div><AvatarRound img={user.Avatar} width={30} name={user.User_Name} /></div>
                                        <div className="ml-5" style={{ textDecoration: user.Completed === true ? "line-through" : "none" }}>
                                            <div className="title">
                                                {user.User_Name}
                                                {user.Viewed === false && <span className="badge badge-menu warning badge-dot" > </span>}
                                            </div>
                                            <div className="subtitle">{user.ID_Action === 1 ? 'Наблюдатель' : 'Исполнитель'}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )

                    )
                    :
                    (
                        data.filter(a => a.ID_Action !== null).sort((a, b) => a.User_Name > b.User_Name ? 1 : -1).length > 0 && (
                            <div className="card_widget_body" style={{ height: '60px' }}>
                                <div style={{ display: 'flex' }}>
                                    <u style={{ fontSize: '12px' }}>{idType === 1 ? ("Выполняет один из:") : ("Выполняет каждый из:")}</u>
                                    {onlyRead === false && (
                                        <div style={{ marginLeft: 'auto' }}>
                                            <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => editModalShow()} />
                                        </div>
                                    )}
                                </div>
                                <div className="m_card_user_row">
                                    {data.filter(a => a.ID_Action !== null).map((user) => (
                                        <div key={user.ID_User} >
                                            <div className="m_card_user_row_item">
                                                <div><AvatarRound img={user.Avatar} width={30} name={user.User_Name} /></div>
                                                <div className="ml-5" style={{ textDecoration: user.Completed === true ? "line-through" : "none" }}>
                                                    <div className="title">
                                                        {user.User_Name}
                                                        {user.Viewed === false && <span className="badge badge-menu warning badge-dot" > </span>}
                                                    </div>
                                                    <div className="subtitle">{user.ID_Action === 1 ? 'Наблюдатель' : 'Исполнитель'}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    )
            }
            {
                modalShow === true && (
                    <Modal show={modalShow} onHide={() => setModalShow(false)} size="">
                        <Modal.Body>
                            <div className="modal_title text-center">Выбор исполнителей</div>
                            {idItem === null ? (
                                <div className="fs-5 text-center mt-15 text-danger">Введите название задачи</div>
                            ) : (
                                idProject === null ? (
                                    <div className="fs-5 text-center mt-15 text-danger">Выберите проект</div>
                                ) : (
                                    loadingAvailable === true ? (
                                        <div className="loader_01 mt-20"></div>
                                    ) : (
                                        <div className="mt-15">
                                            {dataAvailable.map((model) => (
                                                <div key={model.ID_User} className="list_item row_select_ mt-10">
                                                    <div><AvatarRound img={model.Avatar} width={30} name={model.Name_User} /></div>
                                                    <div className="ml-10" style={{ width: '100%' }}>
                                                        <div className="title"> {model.Name_User}</div>
                                                        <div className="subtitle"> {model.Name_Role}</div>
                                                    </div>
                                                    <div className="end">
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id='tooltip-top'>
                                                                    Исполнитель
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <button
                                                                onClick={() => changeHandler(model.ID_User, 2)}
                                                                className={model.ID_Action === 2 ? "btn btn-sm btn-dashed btn-outline-secondary ml-10 active" : "btn btn-sm btn-dashed btn-outline-secondary ml-10"}  >
                                                                <FontAwesomeIcon icon={faUserCheck} className="mr-5-" />
                                                            </button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id='tooltip-top'>
                                                                    Наблюдатель
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <button
                                                                onClick={() => changeHandler(model.ID_User, 1)}
                                                                className={model.ID_Action === 1 ? "btn btn-sm btn-dashed btn-outline-secondary ml-10 active" : "btn btn-sm btn-dashed btn-outline-secondary ml-10"} >
                                                                <FontAwesomeIcon icon={faEye} className="mr-5-" />
                                                            </button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            ))
                                            }




                                            {data.filter(a => a.Find === 0).map((model) => (
                                                <div key={model.ID_User} className="list_item row_select_ mt-10">
                                                    <div><AvatarRound img={model.Avatar} width={30} name={model.User_Name} /></div>
                                                    <div className="ml-10" style={{ width: '100%' }}>
                                                        <div className="title"> {model.User_Name}</div>
                                                    </div>
                                                    <div className="end">
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id='tooltip-top'>
                                                                    Исполнитель
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <button
                                                                onClick={() => changeHandler(model.ID_User, 2)}
                                                                className={model.ID_Action === 2 ? "btn btn-sm btn-dashed btn-outline-secondary ml-10 active" : "btn btn-sm btn-dashed btn-outline-secondary ml-10"}  >
                                                                <FontAwesomeIcon icon={faUserCheck} className="mr-5-" />
                                                            </button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id='tooltip-top'>
                                                                    Наблюдатель
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <button
                                                                onClick={() => changeHandler(model.ID_User, 1)}
                                                                className={model.ID_Action === 1 ? "btn btn-sm btn-dashed btn-outline-secondary ml-10 active" : "btn btn-sm btn-dashed btn-outline-secondary ml-10"} >
                                                                <FontAwesomeIcon icon={faEye} className="mr-5-" />
                                                            </button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            ))
                                            }
                                            <div className="p-2">
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    label="Выполняет каждый ответственный"
                                                    defaultChecked={idType === 2 ? 1 : 0}
                                                    onChange={(e) => typeChangeHandler(e.target.checked === true ? 2 : 1)}
                                                />
                                            </div>
                                        </div>
                                    )

                                )
                            )}
                            {log != null && (
                                <div className="form_error text-center">
                                    {log}
                                </div>
                            )}
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <SrvButton typeBtn="save" loading={loading} size='lg'
                                        onClick={() => saveHundler()}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )
            }
        </div >
    )
}

export default CardUser;